import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAppNavigate } from '../../../../Hooks/back/useAppNavigate';

// Components
import SearchBar from '../../../../Components/Ui/SearchBar';
import WeeklyCalendar from './../ui/WeekCalendar';
import PermitList from '../ui/PermitList';
import WriteFAB from '../ui/WriteFAB';
import FilterBottomSheet from '../ui/FilterBottomSheet';
import Filter from '../ui/Filter';
import Icon from '../../../../Assets/Icon/CustomIcon';

// Reducers / Actions
import { CommonActions } from '../../../../Reducer/CommonReducer';
import {
  setSearchText,
  setDepCd,
  setSearchType,
} from '../../../../Reducer/SearchReducer';
import { PermitActions } from '../../../../Reducer/PermitReducer';
import { useBackStack } from '../../../../Hooks/back/useBackStack';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import WriteModeBottomSheet from '../ui/WriteModeBottomSheet';

export default function M_PER_NEW(props) {
  const { navigate } = useAppNavigate();
  const dispatch = useDispatch();

  const searchInfo = useSelector((state) => state.searchInfo);
  const { selectedFilter, filterLabels } = useSelector((state) => state.permit);
  const searchType = searchInfo.searchType || 'RECENT';
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const [reuseMode, setReuseMode] = React.useState(false);

  useBackStack({
    type: 'navigate',
    onBack: () => navigate('/Home', { replace: true }),
  });
  // 부서 옵션 생성
  const deptOptions = [
    { label: '전체 부서', value: '' },
    ...(searchInfo.depList || []).map((d) => ({
      label: d.name,
      value: d.value,
    })),
  ];

  // 상태 옵션 생성
  const statusOptions = [
    ...(filterLabels || []).map((label) => ({
      label,
      value: label,
    })),
  ];

  // 조회 타입 옵션
  const searchTypeOptions = [
    { label: '최근 50개', value: 'RECENT' },
    { label: '날짜로 조회', value: 'DATE' },
  ];

  // 필터 바에 표시될 아이템
  const filterItems = [
    {
      key: 'searchType',
      label: '조회',
      value:
        searchTypeOptions.find((o) => o.value === searchType)?.label ??
        '최근 50개',
    },
    {
      key: 'dept',
      label: '부서',
      value:
        deptOptions.find((d) => d.value === searchInfo.depCd)?.label ??
        '전체 부서',
    },
    {
      key: 'status',
      label: '상태',
      value: selectedFilter !== '전체' ? selectedFilter : '전체',
    },
  ];

  const filterOptionsByKey = {
    searchType: searchTypeOptions,
    dept: deptOptions,
    status: statusOptions,
  };

  // 필터 선택 핸들러
  const handleFilterSelect = (key, option) => {
    if (key === 'searchType') {
      dispatch(setSearchType(option.value));
    } else if (key === 'dept') {
      dispatch(setDepCd(option.value));
    } else if (key === 'status') {
      dispatch(PermitActions.setSelectedFilter(option.value || '전체'));
    }
  };

  const handleSearchChange = (e) => {
    dispatch(setSearchText(e.target.value));
  };

  const handleWriteClick = () => {
    dispatch(
      BottomSheetActions.SetBottomSheetState({
        bottom: true,
        type: 'permitWriteMode',
      })
    );
  };

  const handleNewWrite = () => {
    dispatch(PermitActions.resetPermitForm('NEW'));
    dispatch(CommonActions.setActiveStep(1));
    dispatch(BottomSheetActions.CloseBottomSheet());
    navigate('/M_Permit/write');
  };

  const filteredPermits = (props.rowData1 || []).filter((item) => {
    const matchesStatus =
      selectedFilter === '전체' ? true : item.status === selectedFilter;

    const searchTarget = `${item.reqNm || ''} ${
      item.workContent || ''
    }`.toLowerCase();
    const matchesSearch = searchTarget.includes(
      (searchInfo.searchText || '').toLowerCase()
    );

    const matchesReuseOwner =
      !reuseMode || String(item.reqId) === String(userInfo?.decUserId);

    return matchesStatus && matchesSearch && matchesReuseOwner;
  });

  return (
    <div className="flex flex-col gap-1 px-4 text-base">
      {/* 검색바 */}
      <SearchBar
        searchBarclassName="bg-white"
        className="bg-transparent p-0"
        value={searchInfo.searchText}
        onChange={handleSearchChange}
        placeholder="신청인, 작업 내용"
      />

      {/* 필터바 + 새로고침 버튼 */}
      <div className="flex items-center gap-1">
        <div className="min-w-0 flex-1">
          <Filter
            className="bg-transparent p-0"
            items={filterItems}
            optionsByKey={filterOptionsByKey}
            onSelect={handleFilterSelect}
          />
        </div>
        <button
          type="button"
          onClick={props.refreshClick}
          className="shrink-0 p-1 text-slate-500 active:opacity-50"
        >
          <Icon.Refresh />
        </button>
      </div>

      {/* 주간 캘린더 - 날짜 조회 모드에서만 표시 */}
      {searchType === 'DATE' && (
        <WeeklyCalendar onDateSelect={props.SearchLogic1} />
      )}

      {reuseMode && (
        <div className="my-2 flex items-center justify-between rounded-xl bg-green-50 px-3 py-3 text-sm text-green-800">
          <span>재사용할 작업허가서를 선택해 주세요.</span>
          <button
            type="button"
            className="font-bold"
            onClick={() => setReuseMode(false)}
          >
            취소
          </button>
        </div>
      )}

      {/* 결과 목록: 필터링된 데이터 전달 */}
      <PermitList
        data={filteredPermits}
        SaveLogic1={props.SaveLogic1}
        reuseMode={reuseMode}
      />

      {/* 바텀시트 */}
      {bottomSheetState.bottom && bottomSheetState.type === 'filter' && (
        <FilterBottomSheet SearchLogic1={props.SearchLogic1} />
      )}

      {bottomSheetState.bottom &&
        bottomSheetState.type === 'permitWriteMode' && (
          <WriteModeBottomSheet
            onWrite={handleNewWrite}
            onReuse={() => {
              dispatch(BottomSheetActions.CloseBottomSheet());
              setReuseMode(true);
            }}
          />
        )}

      {/* 작성 FAB */}
      {!reuseMode && <WriteFAB handleWriteClick={handleWriteClick} />}
    </div>
  );
}
